/** Конвертирует null в undefined для полей, ставших nullable после миграции swagger-схем. */
export const omitNull = <T>(value: T | null | undefined): T | undefined => (value === null ? undefined : value);
